import { TestAnswerFeedbackType } from '@vedalib/editor/lib/elements'
import React from 'react'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { chainName, FieldSegmented, FieldSelect, FormField } from 'components/formKit'
import { Typography } from 'components/uiKit/Typography'
import { useHiddenTestFeedback } from 'services/Branding/fieldConfigs/useFieldConfigs'
import { t } from 'services/Translation'
import { getEnumOption } from 'utils/enum'

import type { TestRankingValueFormType } from './testRankingTypes'

const ANSWER_FEEDBACK = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'answerFeedback',
  label: t('elements.testAnswerFeedback.form.answerFeedback'),
  defaultValue: true,
})

const DISPLAY_FEEDBACK = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'displayFeedback',
  label: t('elements.testAnswerFeedback.form.displayFeedback'),
  defaultValue: true,
})

const GENERAL_TYPE_FB = genElementValueField({
  as: FieldSelect<TestAnswerFeedbackType>,
  name: 'generalTypeFb',
  label: t('elements.testAnswerFeedback.form.generalTypeFb'),
  defaultValue: TestAnswerFeedbackType.validation,
  props: {
    options: [
      getEnumOption('TestFeedbackType', TestAnswerFeedbackType.validation),
      getEnumOption('TestFeedbackType', TestAnswerFeedbackType.info),
    ],
  },
  useConfigs: [useHiddenTestFeedback],
})

const TestRankingFormValue: TestRankingValueFormType = ({ name }) => (
  <Padding bottom gap sides>
    <Typography styleType='hint'>{t('elements.testRanking.form.randomHint')}</Typography>
    <FormField config={chainName(name, ANSWER_FEEDBACK)} />
    <FormField config={chainName(name, DISPLAY_FEEDBACK)} />
    <FormField config={chainName(name, GENERAL_TYPE_FB)} />
  </Padding>
)

export default TestRankingFormValue
